import React from "react";
import HeroLayout from "../components/HeroLayout";
import { Link } from "react-router-dom";
const images = require.context("../assets/images", false);

function Tour_extension() {
     
  return (
    <>
    <HeroLayout>
      <div className="banner-bg bg-bottom" style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./golden-triangle-tour-extensions.jpg")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>Golden Triangle Extensions​</h1>
            </div>
        </div>
        </div>

    </HeroLayout>

   <div className="tour-extension-map mt-80">
  <div className="container">
    <div className="heading center mb-5">
      <h2>Explore India beyond Golden Triangle</h2>
      Enhance your journey beyond Delhi, Agra, and Jaipur with handpicked
      destinations offering spiritual experiences, wildlife safaris, heritage
      exploration, and tropical relaxation.
    </div>
    <div className="row">
<div className="col-md-2"></div>
      <div className="col-md-8">
	    <div className="map-tour desktop-nones mt-80">
		  <img width="100%" src={images("./Golden-Triangle-Tour-Extensions.jpg.jpeg")} />
		</div>
        <div className="map-tour mobile-nones">
          <img width="100%" src={images("./Golden-Triangle-Tour-Extensions.jpg.jpeg")} />
        </div>
      </div>
      <div className="col-md-2"></div>
    </div>
    <div className="center mt-5">
      <p className="center mb-3">
        “India is vast — and your Golden Triangle adventure doesn’t have to end
        at Jaipur. Extend your tour to wildlife sanctuaries, spiritual cities,
        palace towns, or tropical retreats. Choose one or combine multiple
        extensions to make your trip truly unforgettable.”
      </p>
      <p className="mb-5">
        If you want to extend your Golden Triangle Tour to any of these cities
        or any other city in India, kindly click below and fill out the form.
        Our team shall contact you with your customized tour.
      </p>
      <Link className="primary-btn" to="/luxury-golden-triangle-enquiry">
        Tailor Made Tour
      </Link>
    </div>
  </div>
</div>
    </>
  );
}

export default Tour_extension;